import { PayloadAction, createSlice } from '@reduxjs/toolkit';

const initialState = {
  firstName: '',
  middleName: '',
  lastName: '',
  gender: '',
  email: '',
  address: '',
  mobile: '',
  parentalRelationship: '',
  password: '',
};

export const registerParentsSlice = createSlice({
  name: 'registerParents',
  initialState,
  reducers: {
    setFirstName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setMiddleName: (state, action: PayloadAction<string>) => {
      state.middleName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setGender: (state, action: PayloadAction<string>) => {
      state.gender = action.payload;
    },
    setParentalRelationship: (state, action: PayloadAction<string>) => {
      state.parentalRelationship = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setPassword: (state, action: PayloadAction<string>) => {
      state.password = action.payload;
    },
    setAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },
    setMobile: (state, action: PayloadAction<string>) => {
      state.mobile = action.payload;
    },

    reset: (state) => {
      state = initialState;
      return state;
    },
  },
});
export const {
  setFirstName,
  setMiddleName,
  setLastName,
  setGender,
  setEmail,
  setMobile,
  setParentalRelationship,
  setAddress,
  setPassword,
  reset,
} = registerParentsSlice.actions;
export const registerParentsReducer = registerParentsSlice.reducer;
